module.exports = __webpack_public_path__ + "img/Comic03-4.c4d1a466.png";